export default function getCustomerById(customerId = null, customers = {}) {
  return customerId ? customers.find(customer => customer.id === customerId) : null
}
